import { landingMotionInView } from "@/utils/landingMotion";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import card1 from "/image/funnel/features/card1.svg";
import card2 from "/image/funnel/features/card2.svg";
import card3 from "/image/funnel/features/card3.svg";
import card4 from "/image/funnel/features/card4.svg";
import card5 from "/image/funnel/features/card5.svg";
import card6 from "/image/funnel/features/card6.svg";



function StepCard({
    title,
    description,
    numSrc,
    className = "",
}: {
    title: string;
    description: string;
    numSrc: string;
    className?: string;
}) {
    return (
        <div className={`relative ${className} h-full font-nexa`}>
            <div className={`rounded-xl md:rounded-[32px]  h-full p-[1.5px] bg-black border border-white/35`}>
                <div className="relative rounded-xl md:rounded-[32px]  backdrop-blur-[18px] p-6 ">
                    <div className={`flex justify-start`}>
                        <img
                            src={numSrc}
                            alt="feature icon"
                            height={60}
                            width={217}
                            className="pointer-events-none select-none h-auto object-contain"
                            loading="lazy"
                        />
                    </div>


                    <div className={`text-left pt-3`}>
                        <h4 className="font-creato text-xl md:text-2xl text-white leading-tighter leading-tight font-bold">
                            {title}
                        </h4>
                        <p className="mt-2 text-base font-creato md:text-lg  text-white/70 ">
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default function Features() {
    const { t } = useTranslation();

    const featureCards = [
        {
            title: "Instant Funded Accounts",
            description:
                "Start trading immediately with real capital — no challenges, no waiting, no unnecessary steps.",
            icon: card1,
        },
        {
            title: "Fast \u0026 Consistent Payouts",
            description:
                "Withdraw your profits with a reliable payout system designed for serious traders.",
            icon: card2,
        },
        {
            title: "AI-Powered Risk Management",
            description:
                "Stay within limits and protect your capital with intelligent systems guiding your trading behavior.",
            icon: card3,
        },
        {
            title: "Scalable Capital Growth",
            description:
                "Increase your account size as you perform \u2014 scale up to \u00241M\u002B in funded capital.",
            icon: card4,
        },
        {
            title: "Transparent Trading Rules",
            description:
                "No hidden conditions. Clear guidelines so you can trade with full confidence.",
            icon: card5,
        },
        {
            title: "Trade Anytime, Anywhere",
            description:
                "Access your account globally and trade across markets with full flexibility.",
            icon: card6,
        },
    ] as const;

    return (
        <div className="xl:px-0 px-4 max-w-[1240px] font-nexa mx-auto pb-24 pt-14">
            <motion.div className="" {...landingMotionInView}>
                <div className="flex justify-center ">
                    {/* subtitle The lading prop firm */}
                    <motion.div
                        className="w-fit h-auto p-[1.5px] rounded-[20px] bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] flex justify-center items-center"
                        {...landingMotionInView}
                    >
                        <div className="w-fit px-3 bg-black rounded-[20px] p-1 flex items-center justify-center">
                            <span
                                className="bg-clip-text text-[12px] sm:text-[13px] xl:text-base text-transparent font-nexa font-bold uppercase"
                                style={{
                                    backgroundImage:
                                        "linear-gradient(to left, #D7D536, #20CDE2)",
                                    display: "inline-block",
                                }}
                            >
                                {("Choose us")}
                            </span>
                        </div>
                    </motion.div>
                </div>
                <motion.h2
                    className="font-nexa font-normal max-w-2xl mx-auto text-center pt-3 md:pt-0 text-[32px]  md:text-[56px] leading-tight tracking-tight"
                    {...landingMotionInView}
                >
                    {t("Everything You Need to")}{" "}
                    <span className="bg-gradient-to-l px-2 italic from-[#D6E242] via-[#9DDF78] to-60% to-[#79DDC7] bg-clip-text  text-transparent">
                        {t("Trade Like a Pro")}
                    </span>
                </motion.h2>
                <motion.p
                        className="text-base  text-white/50 text-center md:text-xl max-w-xl mx-auto font-normal pt-0 pb-10"
                        {...landingMotionInView}
                    >
                        Powerful tools, real capital, and a system built to help you stay profitable and scale faster.
                    </motion.p>
            </motion.div>

            {/* grid section */}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 pt-8">
                {featureCards.map((card) => (
                    <motion.div
                        key={card.title}
                        className="relative flex justify-start"
                        {...landingMotionInView}
                    >
                        <StepCard
                            title={t(card.title)}
                            description={t(card.description)}
                            numSrc={card.icon}
                        />
                    </motion.div>
                ))}
            </div>
            
        </div>
    )
}